export const getAllAppointments = state => state.appointments.allAppts;
export const getCurrentAppointment = state => state.appointments.currentAppt;
